<template>
    <div class="intro-teaser grid grid__base" :class="bemFacets">
        <div class="intro-teaser--container grid--container">
            <div class="intro-teaser--row grid--row">
                <div class="intro-teaser--col grid--col">
                    <div class="intro-teaser--back-link" v-if="breadcrumb">
                        <base-btn tag="router-link" :to="breadcrumb.path" :facets="['has-grid', 'back-link']">
                            <base-icon symbol="arrowback" size="medium"/>
                            {{ breadcrumb.label }}
                        </base-btn>
                    </div>
                    <h1 class="intro-teaser--title">
                        {{ title }}
                    </h1>
                    <p class="intro-teaser--description">{{ lead }}</p>
                    <div class="intro-teaser--buttons" v-if="link_left || link_right">
                        <base-btn tag="router-link"
                                class="intro-teaser--button"
                                v-if="link_left"
                                :to="link_left.path"
                                :facets="['primary']">
                            {{ link_left.label }}
                        </base-btn>
                        <base-btn tag="router-link"
                                class="intro-teaser--button"
                                v-if="link_right"
                                :to="link_right.path"
                                :facets="['secondary']">
                            {{ link_right.label }}
                        </base-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('intro-teaser')],
        props: {
            title: {
                type: String,
                required: true,
            },
            lead: {
                type: String,
                required: true,
            },
            /** @type {ILink} */
            breadcrumb: {
                type: Object,
                default() {
                    return null;
                },
            },
            /** @type {ILink} */
            link_left: {
                type: Object,
                default() {
                    return null;
                },
            },
            /** @type {ILink} */
            link_right: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
    };
</script>
